import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: auto;
  padding: 40px 16px 16px 16px;
  background-color: ${({ theme: { colors } }) =>
    colors.colorWithOpacityGenerator('background.default', 0.7)};
`;

export const StyledButtonContainer = styled.div`
  width: fit-content;
  min-width: 300px;
`;

export const StyledSearchContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const StyledLoading = styled.img`
  width: 8%;
  height: auto;
  align-self: center;
`;
